import DecorationLine from './DecorationLine';

export default DecorationLine;
